import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Col, Row, Skeleton, Tag, notification } from "antd";
import { useEffect, useState } from "react";
import "./Commons.scss";
import { capitalizeString, getCityNameByCode } from "../../../shared/util";
import { getData } from "../../../controllers/capacities";
import Moment from "react-moment";
import {
  RequestStatus,
  RecordStatus,
  Contact,
  DataItem,
  routerData,
  PageSetting,
} from "../..";
import { saveRequest, sendNotification } from "../../../controllers/connection";
import { getSended } from "../../../controllers/store/actions/connection/connection-sended-actions";
import { RequestConnection } from "../../../models/RequestConnection";
import ConnectionRequest from "../../components/Forms/Modal/ConnectionRequest/Connection-Request";
import { useSelector } from "react-redux";
import store from "../../../controllers/store";
import useRecomendations from "../../../hooks/recomendations-entities-hook";
import RecomendationList from "../../components/Recomedations";
type NotificationType = "success" | "info" | "warning" | "error";
const dispatch = store.dispatch;

const CommonsDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let { params } = location.state;
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const { result, getRecomendations } = useRecomendations();
  const [api, contextHolder] = notification.useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contact, setContact] = useState<Contact>();
  const user = useSelector((state: any) => {
    return state.user.user;
  });

  const go = (params: routerData, entity: any) => {
    navigate(`/${entity}/${params.id}`, { state: { params, entity } });
  };

  const openNotificationWithIcon = (type: NotificationType) => {
    api[type]({
      message: "UNAB",
      description: "Solicitud enviada correctamente.",
    });
  };

  const [common, setCommon] = useState({} as any);
  const [dependencie, setDependencie] = useState({} as any);

  useEffect(() => {
    const getCommon = async () => {
      setLoading(true);
      const commonData = await getData("commons", {
        filter: `filter[id][_eq]=${params.id}&`,
      });

      if (commonData.length > 0) {
        setCommon(commonData[0]);
        if (commonData[0].dependencie_value) {
          console.log("commonData[0]", commonData[0].dependencie_value);
          const colecction = commonData[0].dependencie_type.collection_name;
          const value = commonData[0].dependencie_value;

          const dependencieData = await getData(colecction, {
            filter: `filter[id][_eq]=${value}&`,
          });

          if (dependencieData.length > 0) {
            setDependencie(dependencieData[0]);
            setLoading(false);
          }
        }
      }
    };

    getRecomendations("all", { filter: "" }, 1, 5);
    getCommon();
  }, []);

  return (
    <div style={{ width: "100%", height: "max-content" }}>
      <ConnectionRequest
        open={isModalOpen}
        onOk={(value: any, text: string) => {
          console.log("contact", contact);
          const request = new RequestConnection(
            "",
            text,
            user.me,
            {
              name: contact?.name || "",
              email: contact?.email || "",
              organization_name:
                contact?.organization_name || contact?.name || "",
              type: contact?.type || "",
            },
            RequestStatus.Pending,
            value.requestType || "",
            contact?.type
          );

          saveRequest(request);
          //sendNotification(request);
          setIsModalOpen(false);
          openNotificationWithIcon("success");
          dispatch(
            getSended(
              "connection_request",
              {
                meta: "filter_count",
                filter: `&filter[user_created][id][_eq]=${user.me.id}&filter[status][_eq]=${RecordStatus.Active}`,
              },
              1,
              10
            )
          );
        }}
        onCancel={() => setIsModalOpen(false)}
        contact={{
          name: contact?.name || "",
          email: contact?.email || "",
          organization_name: contact?.organization_name || "",
          type: contact?.type || "",
        }}
      />
      <Skeleton loading={loading} active className="full-width">
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={12} md={8} lg={16}>
            <h1 className="conection-heading-section">Datos Generales</h1>
            <Card
              className="ant-card-conection ant-card-conection-border"
              onClick={() => {}}
              hoverable
              style={{ width: "100%", marginBottom: 30 }}
            >
              <Row gutter={[8, 8]} style={{ width: "100%" }}>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Nombre</h2>
                  <p className="conection-value">
                    {capitalizeString(common?.nombre || "")}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Descripción</h2>
                  <p className="conection-value text-justify">
                    {capitalizeString(common?.descripcion || "No informa")}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Área del conocimiento</h2>
                  <p className="conection-value">
                    {capitalizeString(
                      common?.area_de_conocimiento?.AREA_DE_CONOCIMIENTO
                    ) || ""}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Gran área de conocimiento</h2>
                  <p className="conection-value">
                    {capitalizeString(
                      common?.gran_area_de_conocimiento
                        ?.GRAN_AREA_DE_CONOCIMIENTO || ""
                    )}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">
                    Especialidad del conocimiento
                  </h2>
                  <p className="conection-value">
                    {capitalizeString(
                      common.especialidad_de_conocimiento
                        ?.ESPECIALIDAD_DE_CONOCIMIENTO
                    ) || ""}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Departamento</h2>
                  <p className="conection-value">
                    {getCityNameByCode(common?.city)?.departamento ||
                      common.stateRaw ||
                      ""}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Ciudad</h2>
                  <p className="conection-value">
                    {getCityNameByCode(common?.city)?.municipio ||
                      common.cityRaw ||
                      ""}
                  </p>
                </Col>
                {common?.features ? (
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">Características</h2>
                    <p className="conection-value">
                      {capitalizeString(common?.features || "sin definir")}
                    </p>
                  </Col>
                ) : null}

                {common?.update_date ? (
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">Última Actualización</h2>
                    <p className="conection-value">
                      <Moment format="DD/MM/YYYY">{common?.update_date}</Moment>
                    </p>
                  </Col>
                ) : null}

                {common?.recognized_min ? (
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">
                      Reconociento Minciencias (Sí/No){" "}
                    </h2>
                    <p className="conection-value">
                      {common?.recognized_min === 1 ? "Si" : "No"}
                    </p>
                  </Col>
                ) : null}

                <Col xs={24} sm={12} md={8} lg={12}></Col>
                {common?.url ? (
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <h2 className="conection-label">URL</h2>
                    {common?.url ? (
                      <Button
                        type="primary"
                        onClick={() => {
                          const url = common?.url?.startsWith("http")
                            ? common.url
                            : `https://${common.url}`;
                          window.open(url, "_blank");
                        }}
                      >
                        Página Web
                      </Button>
                    ) : (
                      "Sin url"
                    )}
                  </Col>
                ) : null}
              </Row>
            </Card>
            <h1 className="conection-heading-section">
              Dependencia de la entidad
            </h1>
            <Card
              className="ant-card-conection ant-card-conection-border"
              onClick={() => {}}
              hoverable
              style={{ width: "100%", marginBottom: 30 }}
            >
              <Row gutter={[8, 8]} style={{ width: "100%" }}>
                {dependencie?.id ? (
                  <>
                    <Col xs={24} sm={12} md={8} lg={16}>
                      {dependencie?.actor_type?.collection_name ===
                      "commons" ? (
                        <Button
                          className="connection-font"
                          size="middle"
                          onClick={() => {
                            go(
                              {
                                id: dependencie.id,
                                name: dependencie.nombre,
                                type: dependencie.actor_type.actor,
                              },
                              "commons"
                            );
                          }}
                        >
                          {dependencie.nombre}
                        </Button>
                      ) : null}
                      {dependencie?.actor_type?.collection_name === "groups" ? (
                        <Button
                          className="connection-font"
                          size="middle"
                          onClick={() => {
                            go(
                              {
                                id: dependencie.id,
                                name: dependencie.nme_grupo_gr,
                                type: dependencie.actor_type.actor,
                              },
                              "groups"
                            );
                          }}
                        >
                          {dependencie.nme_grupo_gr}
                        </Button>
                      ) : null}
                      {dependencie?.actor_type?.collection_name ===
                      "entities" ? (
                        <Button
                          className="connection-font"
                          size="middle"
                          onClick={() => {
                            go(
                              {
                                id: dependencie.id,
                                name: dependencie.social_reason,
                                type: dependencie.actor_type.actor,
                              },
                              "entities"
                            );
                          }}
                        >
                          {dependencie.social_reason}
                        </Button>
                      ) : null}
                      {dependencie?.actor_type?.collection_name ===
                      "universities" ? (
                        <Button
                          size="middle"
                          className="connection-font"
                          onClick={() => {
                            go(
                              {
                                id: dependencie.id,
                                name: dependencie.institution_name,
                                type: dependencie.actor_type.actor,
                              },
                              "universities"
                            );
                          }}
                        >
                          {dependencie.social_reason}
                        </Button>
                      ) : null}
                      {dependencie?.actor_type?.collection_name ===
                      "searchers" ? (
                        <Button
                          className="connection-font"
                          size="middle"
                          onClick={() => {
                            go(
                              {
                                id: dependencie.id,
                                name: dependencie.nombre,
                                type: dependencie.actor_type.actor,
                              },
                              "searchers"
                            );
                          }}
                        >
                          {dependencie.social_reason}
                        </Button>
                      ) : null}
                    </Col>
                  </>
                ) : null}
              </Row>
            </Card>
          </Col>
          {user?.me ? (
            <Col xs={24} sm={12} md={8} lg={8}>
              <h1 className="conection-heading-section">Sugerencias</h1>
              <Card
                className="ant-card-conection ant-card-conection-border"
                onClick={() => {}}
                hoverable
                style={{ width: "100%", marginBottom: 30 }}
              >
                <Skeleton
                  loading={result.loading}
                  active
                  className="full-width"
                >
                  <RecomendationList
                    totalPages={result.pagination?.total}
                    onPaginationChanged={(page) => {
                      getRecomendations("all", { filter: {} }, page, 5);
                      setPage(page);
                    }}
                    onConnect={(contact) => {
                      setContact({
                        name: contact.title,
                        type: contact.description,
                        email: contact.contact_email,
                      });
                      setIsModalOpen(!isModalOpen);
                    }}
                    data={result.values
                      .filter((r) => r.id !== params?.id)
                      .map((recomendation: any) => {
                        return {
                          title: recomendation.name,
                          description: `${recomendation.type.actor} - ${recomendation.city}`,
                          avatar: "",
                          contact_email: recomendation.contact_email,
                        } as DataItem;
                      })}
                  />
                </Skeleton>
              </Card>
            </Col>
          ) : null}
        </Row>
      </Skeleton>
    </div>
  );
};

export default CommonsDetail;
